import React from 'react'
import styled from 'styled-components'
import { CircleButton, Flex, mq } from '@revolut/ui-kit'
import { NavigationClose } from '@revolut/icons'
import { Props } from '../CardSlide'

const FixedCircleButton = styled(CircleButton)`
  position: fixed;
  @media ${mq('all')} {
    right: 2rem;
    top: 2rem;
  }
`

const StickyFlex = styled(Flex).attrs({
  width: '100vw',
  height: '4rem',
  bg: 'white',
  alignItems: 'center',
  px: '1rem',
})`
  position: sticky;
  top: 0;
  z-index: 1;
`

type CloseButtonType = { onClose: Props['onClose'] }

export const CloseButton: React.FC<CloseButtonType> = ({ onClose }) =>
  !onClose ? null : (
    <>
      <FixedCircleButton
        hide='*-md'
        variant='outline'
        elevation={0}
        scaleOnHover={false}
        onClick={onClose}
        size='md'
      >
        <NavigationClose size='24' color='grey-50' />
      </FixedCircleButton>
      <StickyFlex hide='md-*'>
        <NavigationClose size='24' color='grey-50' onClick={onClose} />
      </StickyFlex>
    </>
  )
